module.exports = __webpack_public_path__ + "static/media/Rifton Norm.b4911d20.otf";